angular.module('gym.sequences', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.sequences', {
    url: '/sequences',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.sequences.optIn', {
    url: '/sequences/toggle',
    controller: 'SequencesOptInCtrl',
    template: require('templates/gyms/sequences/toggle.html.slim')
  }).state('gym.sequences.list', {
    url: '/sequences?triggerValue',
    template: require('templates/gyms/sequences/list.html.slim')
  }).state('gym.sequences.archived-sequences', {
    url: '/sequences/archived_list',
    template: require('templates/gyms/sequences/archived_list.html.slim')
  }).state('gym.sequences.new', {
    url: '/sequences/new',
    controller: 'EditSequenceCtrl',
    template: require('templates/gyms/sequences/edit.html.slim'),
    resolve: {
      sequence: ["Sequences", function(Sequences) {
        return Sequences.get('new');
      }],
      templates: ["Templates", function(Templates) {
        var params;
        params = {
          count: 1500,
          'filters[for_general_use]': true
        };
        return Templates.getList(params);
      }],
      reports: ["Reports", function(Reports) {
        return Reports.getList({
          count: 1000
        });
      }]
    }
  }).state('gym.sequences.edit', {
    url: '/sequences/:sequenceId/edit',
    controller: 'EditSequenceCtrl',
    template: require('templates/gyms/sequences/edit.html.slim'),
    resolve: {
      sequence: ["$stateParams", "Sequences", function($stateParams, Sequences) {
        return Sequences.get($stateParams.sequenceId);
      }],
      templates: ["Templates", function(Templates) {
        var params;
        params = {
          count: 1500,
          'filters[for_general_use]': true
        };
        return Templates.getList(params);
      }],
      reports: ["Reports", function(Reports) {
        return Reports.getList({
          count: 1000
        });
      }]
    }
  }).state('gym.sequences.show', {
    url: '/sequences/:sequenceId',
    template: require('templates/gyms/sequences/show.html.slim')
  }).state('gym.sequences.bulk_enrol', {
    url: '/bulk_manual_sequence_enrolments/new?sequenceId',
    template: require('templates/gyms/sequences/bulk_enrol.html.slim')
  });
}]);
